/*
 * Currency tools
 *
 * Copyright (c) 2015 Caroline Schnapp (mllegeorgesand@gmail.com)
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 */

if (typeof Currency === 'undefined') {
  var Currency = {};
}

Currency.cookie = {
  configuration: {
    expires: 365,
    path: '/',
    domain: window.location.hostname
  },
  name: 'smartdoll-currency',
  write: function(currency) {
    Cookies.set(this.name, currency, this.configuration);
  },
  read: function() {
    return Cookies.get(this.name);
  },
  destroy: function() {
    Cookies.remove(this.name, this.configuration);
  }
};

Currency.moneyFormats = {
  "USD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} USD",
    "name": "United States Dollars - USD"
  },
  "EUR": {
    "money_format": "&euro;{{amount}}",
    "money_with_currency_format": "&euro;{{amount}} EUR",
    "name": "Euro - EUR"
  },
  "GBP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} GBP",
    "name": "United Kingdom Pounds - GBP"
  },
  "CAD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} CAD",
    "name": "Canada Dollars - CAD"
  },
  "ALL": {
    "money_format": "Lek {{amount}}",
    "money_with_currency_format": "Lek {{amount}} ALL",
    "name": "Albania Leke - ALL"
  },
  "DZD": {
    "money_format": "DA {{amount}}",
    "money_with_currency_format": "DA {{amount}} DZD",
    "name": "Algeria Dinars - DZD"
  },
  "AOA": {
    "money_format": "Kz{{amount}}",
    "money_with_currency_format": "Kz{{amount}} AOA",
    "name": "Angola Kwanza - AOA"
  },
  "ARS": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} ARS",
    "name": "Argentina Pesos - ARS"
  },
  "AMD": {
    "money_format": "{{amount}} AMD",
    "money_with_currency_format": "{{amount}} AMD",
    "name": "Armenia Drams - AMD"
  },
  "AWG": {
    "money_format": "Afl{{amount}}",
    "money_with_currency_format": "Afl{{amount}} AWG",
    "name": "Aruba Guilders - AWG"
  },
  "AUD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} AUD",
    "name": "Australia Dollars - AUD"
  },
  "BBD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} Bds",
    "name": "Barbados Dollars - BBD"
  },
  "AZN": {
    "money_format": "m.{{amount}}",
    "money_with_currency_format": "m.{{amount}} AZN",
    "name": "Azerbaijan New Manats - AZN"
  },
  "BDT": {
    "money_format": "Tk {{amount}}",
    "money_with_currency_format": "Tk {{amount}} BDT",
    "name": "Bangladesh Taka - BDT"
  },
  "BSD": {
    "money_format": "BS${{amount}}",
    "money_with_currency_format": "BS${{amount}} BSD",
    "name": "Bahamas Dollars - BSD"
  },
  "BHD": {
    "money_format": "{{amount}}0 BD",
    "money_with_currency_format": "{{amount}}0 BHD",
    "name": "Bahrain Dinars - BHD"
  },
  "BYR": {
    "money_format": "Br {{amount}}",
    "money_with_currency_format": "Br {{amount}} BYR",
    "name": "Belarus Rubles - BYR"
  },
  "BZD": {
    "money_format": "BZ${{amount}}",
    "money_with_currency_format": "BZ${{amount}} BZD",
    "name": "Belize Dollars - BZD"
  },
  "BTN": {
    "money_format": "Nu {{amount}}",
    "money_with_currency_format": "Nu {{amount}} BTN",
    "name": "Bhutan Ngultrum - BTN"
  },
  "BAM": {
    "money_format": "KM {{amount_with_comma_separator}}",
    "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM",
    "name": "Bosnia Herzegovina C. Marka - BAM"
  },
  "BRL": {
    "money_format": "R$ {{amount_with_comma_separator}}",
    "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL",
    "name": "Brazil Reais - BRL"
  },
  "BOB": {
    "money_format": "Bs{{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB",
    "name": "Bolivia Bolivianos - BOB"
  },
  "BWP": {
    "money_format": "P{{amount}}",
    "money_with_currency_format": "P{{amount}} BWP",
    "name": "Botswana Pulas - BWP"
  },
  "BND": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} BND",
    "name": "Brunei Dollars - BND"
  },
  "BGN": {
    "money_format": "{{amount}} лв",
    "money_with_currency_format": "{{amount}} лв BGN",
    "name": "Bulgaria Leva - BGN"
  },
  "MMK": {
    "money_format": "K{{amount}}",
    "money_with_currency_format": "K{{amount}} MMK",
    "name": "Myanmar Kyats - MMK"
  },
  "KHR": {
    "money_format": "KHR{{amount}}",
    "money_with_currency_format": "KHR{{amount}}",
    "name": "Cambodia Riels - KHR"
  },
  "KYD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} KYD",
    "name": "Cayman Islands Dollars - KYD"
  },
  "XAF": {
    "money_format": "FCFA{{amount}}",
    "money_with_currency_format": "FCFA{{amount}} XAF",
    "name": "CFA BEAC Francs - XAF"
  },
  "CLP": {
    "money_format": "${{amount_no_decimals}}",
    "money_with_currency_format": "${{amount_no_decimals}} CLP",
    "name": "Chile Pesos - CLP"
  },
  "CNY": {
    "money_format": "&#165;{{amount}}",
    "money_with_currency_format": "&#165;{{amount}} CNY",
    "name": "China Yuan Renminbi - CNY"
  },
  "COP": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} COP",
    "name": "Colombia Pesos - COP"
  },
  "CRC": {
    "money_format": "&#8353; {{amount_with_comma_separator}}",
    "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC",
    "name": "Costa Rica Colones - CRC"
  },
  "HRK": {
    "money_format": "{{amount_with_comma_separator}} kn",
    "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK",
    "name": "Croatia Kuna - HRK"
  },
  "CZK": {
    "money_format": "{{amount_with_comma_separator}} K&#269;",
    "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;",
    "name": "Czech Republic Koruny - CZK"
  },
  "DKK": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "kr.{{amount_with_comma_separator}}",
    "name": "Denmark Kroner - DKK"
  },
  "DOP": {
    "money_format": "RD$ {{amount}}",
    "money_with_currency_format": "RD$ {{amount}}",
    "name": "Dominican Republic Pesos - DOP"
  },
  "XCD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "EC${{amount}}",
    "name": "East Caribbean Dollars - XCD"
  },
  "EGP": {
    "money_format": "LE {{amount}}",
    "money_with_currency_format": "LE {{amount}} EGP",
    "name": "Egypt Pounds - EGP"
  },
  "ETB": {
    "money_format": "Br{{amount}}",
    "money_with_currency_format": "Br{{amount}} ETB",
    "name": "Ethiopia Birr - ETB"
  },
  "XPF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF",
    "name": "CFP Francs - XPF"
  },
  "FJD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "FJ${{amount}}",
    "name": "Fiji Dollars - FJD"
  },
  "GMD": {
    "money_format": "D {{amount}}",
    "money_with_currency_format": "D {{amount}} GMD",
    "name": "Gambia Dalasi - GMD"
  },
  "GHS": {
    "money_format": "GH&#8373;{{amount}}",
    "money_with_currency_format": "GH&#8373;{{amount}}",
    "name": "Ghana Cedis - GHS"
  },
  "GTQ": {
    "money_format": "Q{{amount}}",
    "money_with_currency_format": "{{amount}} GTQ",
    "name": "Guatemala Quetzales - GTQ"
  },
  "GYD": {
    "money_format": "G${{amount}}",
    "money_with_currency_format": "${{amount}} GYD",
    "name": "Guyana Dollars - GYD"
  },
  "GEL": {
    "money_format": "{{amount}} GEL",
    "money_with_currency_format": "{{amount}} GEL",
    "name": "Georgia Lari - GEL"
  },
  "HNL": {
    "money_format": "L {{amount}}",
    "money_with_currency_format": "L {{amount}} HNL",
    "name": "Honduras Lempiras - HNL"
  },
  "HKD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "HK${{amount}}",
    "name": "Hong Kong Dollars - HKD"
  },
  "HUF": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft",
    "name": "Hungary Forint - HUF"
  },
  "ISK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr ISK",
    "name": "Iceland Kronur - ISK"
  },
  "INR": {
    "money_format": "Rs. {{amount}}",
    "money_with_currency_format": "Rs. {{amount}}",
    "name": "India Rupees - INR"
  },
  "IDR": {
    "money_format": "{{amount_with_comma_separator}}",
    "money_with_currency_format": "Rp {{amount_with_comma_separator}}",
    "name": "Indonesia Rupiahs - IDR"
  },
  "ILS": {
    "money_format": "{{amount}} NIS",
    "money_with_currency_format": "{{amount}} NIS",
    "name": "Israel New Shekels - ILS"
  },
  "JMD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} JMD",
    "name": "Jamaica Dollars - JMD"
  },
  "JPY": {
    "money_format": "&#165;{{amount_no_decimals}}",
    "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY",
    "name": "Japan Yen - JPY"
  },
  "JEP": {
    "money_format": "&pound;{{amount}}",
    "money_with_currency_format": "&pound;{{amount}} JEP",
    "name": "Jersey Pounds - JEP"
  },
  "JOD": {
    "money_format": "{{amount}}0 JD",
    "money_with_currency_format": "{{amount}}0 JOD",
    "name": "Jordan Dinars - JOD"
  },
  "KZT": {
    "money_format": "{{amount}} KZT",
    "money_with_currency_format": "{{amount}} KZT",
    "name": "Kazakhstan Tenge - KZT"
  },
  "KES": {
    "money_format": "KSh{{amount}}",
    "money_with_currency_format": "KSh{{amount}}",
    "name": "Kenya Shillings - KES"
  },
  "KWD": {
    "money_format": "{{amount}}0 KD",
    "money_with_currency_format": "{{amount}}0 KWD",
    "name": "Kuwait Dinars - KWD"
  },
  "KGS": {
    "money_format": "лв{{amount}}",
    "money_with_currency_format": "лв{{amount}}",
    "name": "Kyrgyzstan Soms - KGS"
  },
  "LVL": {
    "money_format": "Ls {{amount}}",
    "money_with_currency_format": "Ls {{amount}} LVL",
    "name": "Latvia Lati - LVL"
  },
  "LBP": {
    "money_format": "L&pound;{{amount}}",
    "money_with_currency_format": "L&pound;{{amount}} LBP",
    "name": "Lebanon Pounds - LBP"
  },
  "LTL": {
    "money_format": "{{amount}} Lt",
    "money_with_currency_format": "{{amount}} Lt",
    "name": "Lithuania Litai - LTL"
  },
  "MGA": {
    "money_format": "Ar {{amount}}",
    "money_with_currency_format": "Ar {{amount}} MGA",
    "name": "Madagascar Ariary - MGA"
  },
  "MKD": {
    "money_format": "ден {{amount}}",
    "money_with_currency_format": "ден {{amount}} MKD",
    "name": "Macedonia Denars - MKD"
  },
  "MOP": {
    "money_format": "MOP${{amount}}",
    "money_with_currency_format": "MOP${{amount}}",
    "name": "Macau Patacas - MOP"
  },
  "MVR": {
    "money_format": "Rf{{amount}}",
    "money_with_currency_format": "Rf{{amount}} MRf",
    "name": "Maldives Rufiyaa - MVR"
  },
  "MXN": {
    "money_format": "$ {{amount}}",
    "money_with_currency_format": "$ {{amount}} MXN",
    "name": "Mexico Pesos - MXN"
  },
  "MYR": {
    "money_format": "RM{{amount}} MYR",
    "money_with_currency_format": "RM{{amount}} MYR",
    "name": "Malaysia Ringgits - MYR"
  },
  "MUR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} MUR",
    "name": "Mauritius Rupees - MUR"
  },
  "MDL": {
    "money_format": "{{amount}} MDL",
    "money_with_currency_format": "{{amount}} MDL",
    "name": "Moldova Lei - MDL"
  },
  "MAD": {
    "money_format": "{{amount}} dh",
    "money_with_currency_format": "Dh {{amount}} MAD",
    "name": "Morocco Dirhams - MAD"
  },
  "MNT": {
    "money_format": "{{amount_no_decimals}} &#8366",
    "money_with_currency_format": "{{amount_no_decimals}} MNT",
    "name": "Mongolia Tugriks - MNT"
  },
  "MZN": {
    "money_format": "{{amount}} Mt",
    "money_with_currency_format": "Mt {{amount}} MZN",
    "name": "Mozambique Meticais - MZN"
  },
  "NAD": {
    "money_format": "N${{amount}}",
    "money_with_currency_format": "N${{amount}} NAD",
    "name": "Namibia Dollars - NAD"
  },
  "NPR": {
    "money_format": "Rs{{amount}}",
    "money_with_currency_format": "Rs{{amount}} NPR",
    "name": "Nepal Rupees - NPR"
  },
  "ANG": {
    "money_format": "&fnof;{{amount}}",
    "money_with_currency_format": "{{amount}} NA&fnof;",
    "name": "Netherlands Antilles Guilders - ANG"
  },
  "NZD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} NZD",
    "name": "New Zealand Dollars - NZD"
  },
  "NIO": {
    "money_format": "C${{amount}}",
    "money_with_currency_format": "C${{amount}} NIO",
    "name": "Nicaragua Cordobas - NIO"
  },
  "NGN": {
    "money_format": "&#8358;{{amount}}",
    "money_with_currency_format": "&#8358;{{amount}} NGN",
    "name": "Nigeria Nairas - NGN"
  },
  "NOK": {
    "money_format": "kr {{amount_with_comma_separator}}",
    "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK",
    "name": "Norway Kroner - NOK"
  },
  "OMR": {
    "money_format": "{{amount_with_comma_separator}} OMR",
    "money_with_currency_format": "{{amount_with_comma_separator}} OMR",
    "name": "Oman Rials - OMR"
  },
  "PKR": {
    "money_format": "Rs.{{amount}}",
    "money_with_currency_format": "Rs.{{amount}} PKR",
    "name": "Pakistan Rupees - PKR"
  },
  "PGK": {
    "money_format": "K {{amount}}",
    "money_with_currency_format": "K {{amount}} PGK",
    "name": "Papua New Guinea Kina - PGK"
  },
  "PYG": {
    "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
    "name": "Paraguay Guarani - PYG"
  },
  "PEN": {
    "money_format": "S/. {{amount}}",
    "money_with_currency_format": "S/. {{amount}} PEN",
    "name": "Peru Nuevos Soles - PEN"
  },
  "PHP": {
    "money_format": "&#8369;{{amount}}",
    "money_with_currency_format": "&#8369;{{amount}} PHP",
    "name": "Philippines Pesos - PHP"
  },
  "PLN": {
    "money_format": "{{amount_with_comma_separator}} zl",
    "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN",
    "name": "Poland Zlotych - PLN"
  },
  "QAR": {
    "money_format": "QAR {{amount_with_comma_separator}}",
    "money_with_currency_format": "QAR {{amount_with_comma_separator}}",
    "name": "Qatar Riyals - QAR"
  },
  "RON": {
    "money_format": "{{amount_with_comma_separator}} lei",
    "money_with_currency_format": "{{amount_with_comma_separator}} lei RON",
    "name": "Romania New Lei - RON"
  },
  "RUB": {
    "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
    "name": "Russia Rubles - RUB"
  },
  "RWF": {
    "money_format": "{{amount_no_decimals}} RF",
    "money_with_currency_format": "{{amount_no_decimals}} RWF",
    "name": "Rwanda Francs - RWF"
  },
  "WST": {
    "money_format": "WS$ {{amount}}",
    "money_with_currency_format": "WS$ {{amount}} WST",
    "name": "Samoa Tala - WST"
  },
  "SAR": {
    "money_format": "{{amount}} SR",
    "money_with_currency_format": "{{amount}} SAR",
    "name": "Saudi Arabia Riyals - SAR"
  },
  "STD": {
    "money_format": "Db {{amount}}",
    "money_with_currency_format": "Db {{amount}} STD",
    "name": "São Tome and Principe Dobras - STD"
  },
  "RSD": {
    "money_format": "{{amount}} RSD",
    "money_with_currency_format": "{{amount}} RSD",
    "name": "Serbian Dinar - RSD"
  },
  "SCR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} SCR",
    "name": "Seychelles Rupees - SCR"
  },
  "SGD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} SGD",
    "name": "Singapore Dollars - SGD"
  },
  "SYP": {
    "money_format": "S&pound;{{amount}}",
    "money_with_currency_format": "S&pound;{{amount}} SYP",
    "name": "Syria Pounds - SYP"
  },
  "ZAR": {
    "money_format": "R {{amount}}",
    "money_with_currency_format": "R {{amount}} ZAR",
    "name": "South Africa Rand - ZAR"
  },
  "KRW": {
    "money_format": "&#8361;{{amount_no_decimals}}",
    "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW",
    "name": "South Korea Won - KRW"
  },
  "LKR": {
    "money_format": "Rs {{amount}}",
    "money_with_currency_format": "Rs {{amount}} LKR",
    "name": "Sri Lanka Rupees - LKR"
  },
  "SEK": {
    "money_format": "{{amount_no_decimals}} kr",
    "money_with_currency_format": "{{amount_no_decimals}} kr SEK",
    "name": "Sweden Kronor - SEK"
  },
  "CHF": {
    "money_format": "SFr. {{amount}}",
    "money_with_currency_format": "SFr. {{amount}} CHF",
    "name": "Switzerland Francs - CHF"
  },
  "TWD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TWD",
    "name": "Taiwan New Dollars - TWD"
  },
  "THB": {
    "money_format": "{{amount}} &#xe3f;",
    "money_with_currency_format": "{{amount}} &#xe3f; THB",
    "name": "Thailand Baht - THB"
  },
  "TZS": {
    "money_format": "{{amount}} TZS",
    "money_with_currency_format": "{{amount}} TZS",
    "name": "Tanzania Shillings - TZS"
  },
  "TTD": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}} TTD",
    "name": "Trinidad and Tobago Dollars - TTD"
  },
  "TND": {
    "money_format": "{{amount}}",
    "money_with_currency_format": "{{amount}} DT",
    "name": "Tunisia Dinars - TND"
  },
  "TRY": {
    "money_format": "{{amount}}TL",
    "money_with_currency_format": "{{amount}}TL",
    "name": "Turkey Lira - TRY"
  },
  "UGX": {
    "money_format": "Ush {{amount_no_decimals}}",
    "money_with_currency_format": "Ush {{amount_no_decimals}} UGX",
    "name": "Uganda Shillings - UGX"
  },
  "UAH": {
    "money_format": "₴{{amount}}",
    "money_with_currency_format": "₴{{amount}} UAH",
    "name": "Ukraine Hryvnia - UAH"
  },
  "AED": {
    "money_format": "Dhs. {{amount}}",
    "money_with_currency_format": "Dhs. {{amount}} AED",
    "name": "United Arab Emirates Dirhams - AED"
  },
  "UYU": {
    "money_format": "${{amount_with_comma_separator}}",
    "money_with_currency_format": "${{amount_with_comma_separator}} UYU",
    "name": "Uruguay Pesos - UYU"
  },
  "VUV": {
    "money_format": "${{amount}}",
    "money_with_currency_format": "${{amount}}VT",
    "name": "Vanuatu Vatu - VUV"
  },
  "VEF": {
    "money_format": "Bs. {{amount_with_comma_separator}}",
    "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF",
    "name": "Venezuela Bolivares - VEF"
  },
  "VND": {
    "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
    "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND",
    "name": "Vietnam Dong - VND"
  },
  "XBT": {
    "money_format": "{{amount}} BTC",
    "money_with_currency_format": "{{amount}} BTC",
    "name": "Bitcoin - BTC"
  },
  "XOF": {
    "money_format": "CFA{{amount}}",
    "money_with_currency_format": "CFA{{amount}} XOF",
    "name": "CFA BCEAO Francs - XOF"
  },
  "ZMW": {
    "money_format": "K{{amount_no_decimals_with_comma_separator}}",
    "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}",
    "name": "Zambia Kwacha - ZMW"
  },
  "XPT": {
    "name": "Platinum Ounces - XPT"
  },
  "LAK": {
    "name": "Laos Kips - LAK"
  },
  "CDF": {
    "name": "Congo/Kinshasa Francs - CDF"
  },
  "KPW": {
    "name": "North Korea Won - KPW"
  },
  "SPL": {
    "name": "Seborga Luigini - SPL"
  },
  "ZWD": {
    "name": "Zimbabwe Dollars - ZWD"
  },
  "LYD": {
    "name": "Libya Dinars - LYD"
  },
  "BIF": {
    "name": "Burundi Francs - BIF"
  },
  "GIP": {
    "name": "Gibraltar Pounds - GIP"
  },
  "ERN": {
    "name": "Eritrea Nakfa - ERN"
  },
  "MWK": {
    "name": "Malawi Kwachas - MWK"
  },
  "CUP": {
    "name": "Cuba Pesos - CUP"
  },
  "CVE": {
    "name": "Cape Verde Escudos - CVE"
  },
  "LSL": {
    "name": "Lesotho Maloti - LSL"
  },
  "XAG": {
    "name": "Silver Ounces - XAG"
  },
  "TOP": {
    "name": "Tonga Pa'anga - TOP"
  },
  "SHP": {
    "name": "Saint Helena Pounds - SHP"
  },
  "HTG": {
    "name": "Haiti Gourdes - HTG"
  },
  "FKP": {
    "name": "Falkland Islands Pounds - FKP"
  },
  "TVD": {
    "name": "Tuvalu Dollars - TVD"
  },
  "GGP": {
    "name": "Guernsey Pounds - GGP"
  },
  "KMF": {
    "name": "Comoros Francs - KMF"
  },
  "IRR": {
    "name": "Iran Rials - IRR"
  },
  "XPD": {
    "name": "Palladium Ounces - XPD"
  },
  "SRD": {
    "name": "Suriname Dollars - SRD"
  },
  "SZL": {
    "name": "Swaziland Emalangeni - SZL"
  },
  "BMD": {
    "name": "Bermuda Dollars - BMD"
  },
  "MRO": {
    "name": "Mauritania Ouguiyas - MRO"
  },
  "YER": {
    "name": "Yemen Rials - YER"
  },
  "SLL": {
    "name": "Sierra Leone Leones - SLL"
  },
  "TJS": {
    "name": "Tajikistan Somoni - TJS"
  },
  "DJF": {
    "name": "Djibouti Francs - DJF"
  },
  "GNF": {
    "name": "Guinea Francs - GNF"
  },
  "SDG": {
    "name": "Sudan Pounds - SDG"
  },
  "IMP": {
    "name": "Isle of Man Pounds - IMP"
  },
  "XDR": {
    "name": "IMF Special Drawing Rights - XDR"
  },
  "LRD": {
    "name": "Liberia Dollars - LRD"
  },
  "ZMK": {
    "name": "Zambia Kwacha - ZMK"
  },
  "XAU": {
    "name": "Gold Ounces - XAU"
  },
  "TMT": {
    "name": "Turkmenistan New Manats - TMT"
  },
  "IQD": {
    "name": "Iraq Dinars - IQD"
  },
  "UZS": {
    "name": "Uzbekistan Sums - UZS"
  },
  "SOS": {
    "name": "Somalia Shillings - SOS"
  },
  "PAB": {
    "name": "Panama Balboas - PAB"
  },
  "CUC": {
    "name": "Cuba Convertible Pesos - CUC"
  },
  "SVC": {
    "name": "El Salvador Colones - SVC"
  },
  "SBD": {
    "name": "Solomon Islands Dollars - SBD"
  }
};

Currency.formatMoney = function(cents, format) {
  if (typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

Currency.currentCurrency = '';

Currency.format = 'money_with_currency_format';

Currency.convertAll = function(oldCurrency, newCurrency, selector, format) {
  jQuery(selector || 'span.money').each(function() {
    // If the amount has already been converted, we leave it alone.
    if (jQuery(this).attr('data-currency') === newCurrency) return;
    // If we are converting to a currency that we have saved, we will use the saved amount.
    if (jQuery(this).attr('data-currency-' + newCurrency)) {
      jQuery(this).html(jQuery(this).attr('data-currency-' + newCurrency));
    } else {
      // Converting to Y for the first time? Let's get to it!
      var cents = 0.0;
      var oldFormat = Currency.moneyFormats[oldCurrency][format || Currency.format] || '{{amount}}';
      var newFormat = Currency.moneyFormats[newCurrency][format || Currency.format] || '{{amount}}';
      if (oldFormat.indexOf('amount_no_decimals') !== -1) {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10) * 100, oldCurrency, newCurrency);
      } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10) / 10, oldCurrency, newCurrency);
      } else {
        cents = Currency.convert(parseInt(jQuery(this).html().replace(/[^0-9]/g, ''), 10), oldCurrency, newCurrency);
      }
      var newFormattedAmount = Currency.formatMoney(cents, newFormat);
      jQuery(this).html(newFormattedAmount);
      jQuery(this).attr('data-currency-' + newCurrency, newFormattedAmount);
    }
    // We record the new currency locally.
    jQuery(this).attr('data-currency', newCurrency);
  });
  this.currentCurrency = newCurrency;
  this.cookie.write(newCurrency);
};

Currency.moneyLang = {
  "ab": "GEL",
  "ady": "RUB",
  "af": "ZAR",
  "ak": "GHS",
  "am": "ETB",
  "as": "INR",
  "ast": "EUR",
  "av": "RUB",
  "ay": "BOB",
  "az_Arab": "IQD",
  "az_Latn": "AZN",
  "az": "AZN",
  "ba": "RUB",
  "bal": "AFN",
  "be": "BYR",
  "bg": "BGN",
  "bi": "VUV",
  "bjt": "XOF",
  "bo": "CNY",
  "bs_Cyrl": "BAM",
  "bs_Latn": "BAM",
  "bs": "BAM",
  "bsc": "XOF",
  "ca": "EUR",
  "ce": "RUB",
  "ceb": "PHP",
  "ch": "USD",
  "ckb": "IQD",
  "cs": "CZK",
  "csb": "PLN",
  "cy": "GBP",
  "da": "DKK",
  "dv": "MVR",
  "dyo": "XOF",
  "dz": "BTN",
  "ee": "GHS",
  "el": "EUR",
  "et": "EUR",
  "eu": "EUR",
  "ff": "XOF",
  "fil": "PHP",
  "fj": "FJD",
  "fo": "DKK",
  "fy": "EUR",
  "gaa": "GHS",
  "gd": "GBP",
  "gil": "AUD",
  "gl": "EUR",
  "gn": "PYG",
  "gsw": "CHF",
  "gu": "INR",
  "gv": "GBP",
  "haw": "USD",
  "he": "ILS",
  "hi": "INR",
  "hif_Latn": "FJD",
  "hif": "FJD",
  "hil": "PHP",
  "ho": "PGK",
  "ht": "HTG",
  "hy": "AMD",
  "id": "IDR",
  "ikt": "CAD",
  "ilo": "PHP",
  "inh": "RUB",
  "is": "ISK",
  "iu_Cans": "CAD",
  "iu_Latn": "CAD",
  "iu": "CAD",
  "ja": "JPY",
  "ka": "GEL",
  "kbd": "RUB",
  "kg": "CDF",
  "kha": "INR",
  "kk_Cyrl": "KZT",
  "kk": "KZT",
  "kl": "DKK",
  "km": "KHR",
  "kn": "INR",
  "knf": "XOF",
  "koi": "RUB",
  "kok": "INR",
  "krc": "RUB",
  "ks_Arab": "INR",
  "ks": "INR",
  "kum": "RUB",
  "kv": "RUB",
  "ky_Cyrl": "KGS",
  "ky": "KGS",
  "lb": "EUR",
  "lbe": "RUB",
  "lez": "RUB",
  "ln": "CDF",
  "lo": "LAK",
  "lua": "CDF",
  "lv": "EUR",
  "mai": "INR",
  "mdf": "RUB",
  "mdh": "PHP",
  "mey": "XOF",
  "mfv": "XOF",
  "mg": "MGA",
  "mh": "USD",
  "mi": "NZD",
  "mk": "MKD",
  "ml": "INR",
  "mn_Cyrl": "MNT",
  "mn_Mong": "CNY",
  "mn": "MNT",
  "mr": "INR",
  "ms_Arab": "BND",
  "mt": "EUR",
  "my": "MMK",
  "myv": "RUB",
  "na": "AUD",
  "nb": "NOK",
  "nd": "USD",
  "niu": "NZD",
  "nn": "NOK",
  "nr": "ZAR",
  "nso": "ZAR",
  "ny": "MWK",
  "or": "INR",
  "os": "GEL",
  "pa_Guru": "INR",
  "pa": "INR",
  "pag": "PHP",
  "pau": "USD",
  "pl": "PLN",
  "ps": "AFN",
  "quc": "GTQ",
  "rm": "CHF",
  "rn": "BIF",
  "rw": "RWF",
  "sa": "INR",
  "sah": "RUB",
  "sat": "INR",
  "sav": "XOF",
  "sd_Arab": "INR",
  "sd_Deva": "INR",
  "sd": "INR",
  "se": "NOK",
  "sg": "XAF",
  "si": "LKR",
  "sl": "EUR",
  "sn": "USD",
  "snf": "XOF",
  "so": "SOS",
  "srr": "XOF",
  "st": "ZAR",
  "te": "INR",
  "tet": "USD",
  "tg_Cyrl": "TJS",
  "tg": "TJS",
  "th": "THB",
  "ti": "ERN",
  "tkl": "NZD",
  "tnr": "XOF",
  "to": "TOP",
  "tpi": "PGK",
  "ts": "ZAR",
  "tsg": "PHP",
  "tt": "RUB",
  "tvl": "AUD",
  "ty": "XPF",
  "tyv": "RUB",
  "tzm_Latn": "MAD",
  "tzm": "MAD",
  "udm": "RUB",
  "ug_Arab": "CNY",
  "ug": "CNY",
  "uz_Arab": "AFN",
  "uz_Cyrl": "UZS",
  "uz_Latn": "UZS",
  "uz": "UZS",
  "ve": "ZAR",
  "vi": "VND",
  "war": "PHP",
  "wni": "KMF",
  "wo": "XOF",
  "xh": "ZAR",
  "yo": "NGN",
  "za": "CNY",
  "zdj": "KMF",
  "zu": "ZAR"
};

Currency.moneyRegion = {
  "AC": "SHP",
  "AD": "EUR",
  "AE": "AED",
  "AF": "AFN",
  "AG": "XCD",
  "AI": "XCD",
  "AL": "ALL",
  "AM": "AMD",
  "AO": "AOA",
  "AQ": "XXX",
  "AR": "ARS",
  "AS": "USD",
  "AT": "EUR",
  "AU": "AUD",
  "AW": "AWG",
  "AX": "EUR",
  "AZ": "AZN",
  "BA": "BAM",
  "BB": "BBD",
  "BD": "BDT",
  "BE": "EUR",
  "BF": "XOF",
  "BG": "BGN",
  "BH": "BHD",
  "BI": "BIF",
  "BJ": "XOF",
  "BL": "EUR",
  "BM": "BMD",
  "BN": "BND",
  "BO": "BOB",
  "BQ": "USD",
  "BR": "BRL",
  "BS": "BSD",
  "BT": "BTN",
  "BU": "BUK",
  "BV": "NOK",
  "BW": "BWP",
  "BY": "BYR",
  "BZ": "BZD",
  "CA": "CAD",
  "CC": "AUD",
  "CD": "CDF",
  "CF": "XAF",
  "CG": "XAF",
  "CH": "CHF",
  "CI": "XOF",
  "CK": "NZD",
  "CL": "CLP",
  "CM": "XAF",
  "CN": "CNY",
  "CO": "COP",
  "CP": "XXX",
  "CR": "CRC",
  "CS": "CSD",
  "CU": "CUP",
  "CV": "CVE",
  "CW": "ANG",
  "CX": "AUD",
  "CY": "EUR",
  "CZ": "CZK",
  "DD": "DDM",
  "DE": "EUR",
  "DG": "USD",
  "DJ": "DJF",
  "DK": "DKK",
  "DM": "XCD",
  "DO": "DOP",
  "DZ": "DZD",
  "EA": "EUR",
  "EC": "USD",
  "EE": "EUR",
  "EG": "EGP",
  "EH": "MAD",
  "ER": "ERN",
  "ES": "EUR",
  "ET": "ETB",
  "EU": "EUR",
  "FI": "EUR",
  "FJ": "FJD",
  "FK": "FKP",
  "FM": "USD",
  "FO": "DKK",
  "FR": "EUR",
  "GA": "XAF",
  "GB": "GBP",
  "GD": "XCD",
  "GE": "GEL",
  "GF": "EUR",
  "GG": "GBP",
  "GH": "GHS",
  "GI": "GIP",
  "GL": "DKK",
  "GM": "GMD",
  "GN": "GNF",
  "GP": "EUR",
  "GQ": "XAF",
  "GR": "EUR",
  "GS": "GBP",
  "GT": "GTQ",
  "GU": "USD",
  "GW": "XOF",
  "GY": "GYD",
  "HK": "HKD",
  "HM": "AUD",
  "HN": "HNL",
  "HR": "HRK",
  "HT": "HTG",
  "HU": "HUF",
  "IC": "EUR",
  "ID": "IDR",
  "IE": "EUR",
  "IL": "ILS",
  "IM": "GBP",
  "IN": "INR",
  "IO": "USD",
  "IQ": "IQD",
  "IR": "IRR",
  "IS": "ISK",
  "IT": "EUR",
  "JE": "GBP",
  "JM": "JMD",
  "JO": "JOD",
  "JP": "JPY",
  "KE": "KES",
  "KG": "KGS",
  "KH": "KHR",
  "KI": "AUD",
  "KM": "KMF",
  "KN": "XCD",
  "KP": "KPW",
  "KR": "KRW",
  "KW": "KWD",
  "KY": "KYD",
  "KZ": "KZT",
  "LA": "LAK",
  "LB": "LBP",
  "LC": "XCD",
  "LI": "CHF",
  "LK": "LKR",
  "LR": "LRD",
  "LS": "ZAR",
  "LT": "EUR",
  "LU": "EUR",
  "LV": "EUR",
  "LY": "LYD",
  "MA": "MAD",
  "MC": "EUR",
  "MD": "MDL",
  "ME": "EUR",
  "MF": "EUR",
  "MG": "MGA",
  "MH": "USD",
  "MK": "MKD",
  "ML": "XOF",
  "MM": "MMK",
  "MN": "MNT",
  "MO": "MOP",
  "MP": "USD",
  "MQ": "EUR",
  "MR": "MRO",
  "MS": "XCD",
  "MT": "EUR",
  "MU": "MUR",
  "MV": "MVR",
  "MW": "MWK",
  "MX": "MXN",
  "MY": "MYR",
  "MZ": "MZN",
  "NA": "NAD",
  "NC": "XPF",
  "NE": "XOF",
  "NF": "AUD",
  "NG": "NGN",
  "NI": "NIO",
  "NL": "EUR",
  "NO": "NOK",
  "NP": "NPR",
  "NR": "AUD",
  "NU": "NZD",
  "NZ": "NZD",
  "OM": "OMR",
  "PA": "PAB",
  "PE": "PEN",
  "PF": "XPF",
  "PG": "PGK",
  "PH": "PHP",
  "PK": "PKR",
  "PL": "PLN",
  "PM": "EUR",
  "PN": "NZD",
  "PR": "USD",
  "PS": "ILS",
  "PT": "EUR",
  "PW": "USD",
  "PY": "PYG",
  "QA": "QAR",
  "RE": "EUR",
  "RO": "RON",
  "RS": "RSD",
  "RU": "RUB",
  "RW": "RWF",
  "SA": "SAR",
  "SB": "SBD",
  "SC": "SCR",
  "SD": "SDG",
  "SE": "SEK",
  "SG": "SGD",
  "SH": "SHP",
  "SI": "EUR",
  "SJ": "NOK",
  "SK": "EUR",
  "SL": "SLL",
  "SM": "EUR",
  "SN": "XOF",
  "SO": "SOS",
  "SR": "SRD",
  "SS": "SSP",
  "ST": "STD",
  "SU": "SUR",
  "SV": "USD",
  "SX": "ANG",
  "SY": "SYP",
  "SZ": "SZL",
  "TA": "GBP",
  "TC": "USD",
  "TD": "XAF",
  "TF": "EUR",
  "TG": "XOF",
  "TH": "THB",
  "TJ": "TJS",
  "TK": "NZD",
  "TL": "USD",
  "TM": "TMT",
  "TN": "TND",
  "TO": "TOP",
  "TP": "TPE",
  "TR": "TRY",
  "TT": "TTD",
  "TV": "AUD",
  "TW": "TWD",
  "TZ": "TZS",
  "UA": "UAH",
  "UG": "UGX",
  "UM": "USD",
  "US": "USD",
  "UY": "UYU",
  "UZ": "UZS",
  "VA": "EUR",
  "VC": "XCD",
  "VE": "VEF",
  "VG": "USD",
  "VI": "USD",
  "VN": "VND",
  "VU": "VUV",
  "WF": "XPF",
  "WS": "WST",
  "XK": "EUR",
  "YE": "YER",
  "YD": "YDD",
  "YT": "EUR",
  "YU": "YUM",
  "ZA": "ZAR",
  "ZM": "ZMW",
  "ZR": "ZRN",
  "ZW": "USD",
  "ZZ": "XAG"
};

Currency.detect = function() {
  var saved = Currency.cookie.read();
  if (saved) {
    return saved;
  }

  var locale = navigator.userLanguage || navigator.language || navigator.browserLanguage || navigator.systemLanguage;
  var lang = locale.replace('-', '_'),
    region = null;

  if (locale.indexOf('-') > -1) {
    var parts = lang.split('_');
    lang = parts.shift();
    region = parts.pop();
  }

  var found = Currency.moneyRegion[region] || Currency.moneyLang[lang];
  if (found) {
    Currency.cookie.write(found);
  }

  return found;
}
